import React from "react"
import BlockContent from "@sanity/block-content-to-react"
import { serializers } from "./Serializers"

export const WysiWyg = props => (
  <BlockContent {...props} serializers={serializers}></BlockContent>
)
